import Svg from '@doordash/component-svg'
import * as React from 'react'
import { ImageProps } from '..'
import t from './strings'

// tslint:disable:max-line-length
export const Transparency: React.FunctionComponent<ImageProps> = ({
  width,
  height,
}) => (
  <Svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 60 60"
    aria-labelledby="valuePropsTitleTransparency valuePropsDescTransparency"
    role="img"
  >
    <title id="valuePropsTitleTransparency">{t.title()}</title>
    <desc id="valuePropsDescTransparency">{t.desc()}</desc>
    <defs>
      <path id="a" d="M0 .14h34.63V34.9H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" fillOpacity="0.01" d="M0 0h60v60H0z" />
      <path
        fill="#FF3008"
        d="M35.85 40.09c.98-.97 4.53-4.24 5.11-4.53.59-.29 8.65 8.56 10.11 10.11 1.23 1.3 4.37 3.5 3.8 6.03-.6 2.52-2 3.16-3.18 3.16-2.52 0-4.27-1.65-6.12-3.5a806.04 806.04 0 01-10.2-10.4c-.3-.38.48-.87.48-.87"
      />
      <path
        fill="#C7C6B7"
        d="M32.48 35.2l6.6 6.88s3.29-2.11 3.1-2.57c-.19-.46-6.78-7.25-6.78-7.25s-3.2 2.39-2.92 2.94"
      />
      <path
        fill="#DA260D"
        d="M36.46 39.35l2.61 2.73s3.3-2.11 3.11-2.57c-.08-.2-1.34-1.57-2.76-3.06-.98.94-2.15 2.09-2.96 2.9"
      />
      <g transform="translate(6 5.34)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          fill="#528C8F"
          d="M4.6 5.54C6.14 3.8 10.71.78 13.82.4c3.1-.39 6.49-.55 10.4 1.17 3.53 1.54 7.6 4.5 9.23 9.23a19.54 19.54 0 01.58 11.37c-.78 2.92-3.85 7.1-6.02 9.04-2.72 2.43-8.26 3.76-11.18 3.7-3.98-.1-8.45-1.94-10.89-4.19C3.43 28.38.81 24.47.22 20.61c-.78-5.06.68-9.43 1.46-10.99.78-1.55 2.92-4.08 2.92-4.08"
          mask="url(#b)"
        />
      </g>
      <path
        fill="#FFF"
        d="M12.71 13.67c1.6-2.31 7.31-5.63 12.25-4.72 5.42 1 8.24 3.33 10.64 7.33 3.02 5.02 1.71 12.75-2 16.17-3.72 3.41-9.04 5.42-14.36 3.71-5.32-1.7-9.74-7.73-9.84-12.85-.1-5.12 1.9-7.6 3.31-9.64"
      />
      <path
        fill="#3B646E"
        d="M35.4 32.26s-3.2 2.39-2.92 2.94l1.4 1.46.14-.12c.81-.73 1.76-1.78 2.66-2.95l-1.28-1.33"
      />
      <path
        fill="#FFF"
        d="M38.54 46.57l-.62-.73 8.87-7.6.62.73zm1.99 2.23l-.58-.76 8.66-6.54.57.76z"
      />
      <path
        fill="#C7C6B7"
        d="M33.34 19.55a9.45 9.45 0 00-6.5-7.1c-4.92-1.64-9.54 1.04-9.58 1.07l-.49-.82c.2-.12 5.05-2.92 10.37-1.15a10.37 10.37 0 017.12 7.8l-.93.2z"
      />
    </g>
  </Svg>
)

export default Transparency
